import { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import SelectableState from '../../../contexts/local/selectable/SelectableState';
import OccupiedTraySlotSelector from '../discarding/tray/OccupiedTraySlotSelector';
import TraySelection from '../seeding/TraySelection';
import ConfirmTransplanting from './ConfirmTransplanting';
import NumPlantsPerChannel from './NumPlantsPerChannel';
import PanelSelector from './PanelSelector';
import PanelSlotSelector from './PanelSlotSelector';
import ProcessContext from '../../../contexts/process/ProcessContext';
import Loading from '../../ui-elements/Loading';

const Transplanting = () => {
  const { processFinished, occupancyArray, additionalProcessInformation, finishProcess } = useContext(ProcessContext);

  const [availableItems, setAvailableItems] = useState([]);

    const navigate = useNavigate();
  const currentProcessStep = additionalProcessInformation?.processStep;
  const tray = additionalProcessInformation?.sourceEntity;
  const panel = additionalProcessInformation?.destinationEntity;
  const completingRef = useRef(false);

  useEffect(() => {
    return () => {
      if (!completingRef.current) {
        finishProcess();
      }
    }
  },[]);

  /* If any process information changes, rerender and map occupancy accordingly */
  useEffect(() => {
    if (currentProcessStep && currentProcessStep === 2) {
      setAvailableItems(occupancyArray.filter((item) => !item.isAvailable).map((item) => item.index));
    }
    else if (currentProcessStep && currentProcessStep === 5) {
      setAvailableItems(
        additionalProcessInformation?.virtualOccupancy
          ?.map((channel) =>
            channel.filter((block) => block.isOccupiable).map((block) => block.startPlantSlotOrdinalNumber)
          )
          .flat() ?? []
      );
    }
  }, [occupancyArray, additionalProcessInformation]);

  /* If the process is finished, after wall slot selection we will not redirect to panel selection, but to main screen */
  useEffect(() => {
    if (processFinished) {
      navigate('/');
    }
  }, [processFinished]);

  const renderComponentsBasedOnProcessStep = () => {
    if(!currentProcessStep) return <Loading fullScreen={true} />
    switch (currentProcessStep) {
      case 1:
        return <TraySelection />
      case 2:
        return <SelectableState availableItems={availableItems}>
                {tray ? <OccupiedTraySlotSelector /> : <Loading fullScreen={true} />}
              </SelectableState>
      case 3:
        return <PanelSelector />
      case 4:
        return <NumPlantsPerChannel />
      case 5:
        return <SelectableState availableItems={availableItems}>
                {panel ? <PanelSlotSelector /> : <Loading fullScreen={true} />}
              </SelectableState>
      case 6:
        return <ConfirmTransplanting completingRef={completingRef} />
      default:
        break;
    }
  };

  return (
    <div id='transplanting-container' className='process-container'>
      {renderComponentsBasedOnProcessStep()}
    </div>
  );
};

export default Transplanting;